module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"p17s4titles":[{"titleS":false,"title":"Find below some of our partner universities"}]},"es":{"p17s4titles":[{"titleS":false,"title":"Aquí tienes algunas universidades amigas"}]}}')
  delete Component.options._Ctor
}
